import React, { useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';
import ajaxReport from '../../../util/remote/ajaxReport';
import { useReport } from '../../../DataStore/ReportContext';

const AlertAutoComment = () => {
    const [loading, setLoading] = useState(false);
    const { setNotify } = useTheme();

    const { autoCommentControl, setAutoCommentControl } = useReport();

    const handleClose = () => {
        setAutoCommentControl({
            show: false,
            report: null,
            enable: false,
            callback: null,
        });
    };

    if (!autoCommentControl?.report) return null;

    const isEnabling = autoCommentControl.enable;

    const confirm = async () => {
        setLoading(true);

        // Change this method name if your backend uses a different one
        const server_response = await ajaxReport.toggleReportAutoComment(
            autoCommentControl.report.id,
            isEnabling ? 1 : 0
        );

        setLoading(false);

        if (server_response.status === "OK") {
            if (typeof autoCommentControl.callback === "function") {
                autoCommentControl.callback();
            }

            setNotify(
                <Notification
                    type='success'
                    message={server_response.message || `Automatic report comments ${isEnabling ? 'enabled' : 'disabled'} successfully.`}
                />
            );
        } else {
            setNotify(
                <Notification
                    type='danger'
                    message={server_response.message || 'Failed to update automatic report comments setting.'}
                />
            );
        }

        handleClose();
    };

    return (
        <BsModal
            show={autoCommentControl.show}
            onClose={handleClose}
            title={isEnabling ? "Enable Automatic Comments" : "Disable Automatic Comments"}
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && (
                        <>
                            <button className="btn btn-secondary" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                className={`btn ${isEnabling ? 'btn-success' : 'btn-danger'}`}
                                onClick={confirm}
                            >
                                Confirm
                            </button>
                        </>
                    )}
                </>
            }
        >
            <div className="d-flex justify-content-center align-items-center flex-column">
                <i
                    className={`fa ${isEnabling ? 'fa-toggle-on text-success' : 'fa-toggle-off text-danger'}`}
                    style={{ fontSize: "42px", lineHeight: "1", marginTop: "20px" }}
                ></i>

                <h5
                    className='mt-3 text-dark text-center'
                    style={{ fontSize: '17px' }}
                >
                    Please confirm that you want to{" "}
                    <i>{isEnabling ? "enable" : "disable"}</i>{" "}
                    automatic report comments for{" "}
                    <i>{autoCommentControl.report.title}</i>.
                </h5>

                <p className="text-muted text-center mt-2 mb-0" style={{ maxWidth: "500px" }}>
                    {isEnabling
                        ? "When enabled, the system will automatically generate report comments for this report."
                        : "When disabled, the system will stop automatically generating report comments for this report."}
                </p>
            </div>
        </BsModal>
    );
};

export default AlertAutoComment;